import React, {forwardRef} from 'react'

import NavigationMenuItem from "../../../menu-items/menu-item"
import NavigationMenuItemCustomView from "../../../menu-items/custom-view/menu-item-custom-view"
// @ts-ignore
import NavigationMenuItemPortfolio from "../../../menu-items/portfolio/menu-item-portfolio";

const NavigationMenuProjectsViewsItem = forwardRef((props:any, ref: any) => {

    switch (props.item.type) {
        case 'all'      : return <NavigationMenuItem ref={ref}
                                                     {...props}
                                                     name="All projects"
                                                     icon="i5-projects-list"
                                                     onClick={()=>{gd.goTo('o/'+gd.companyId+'/projects')}}/>
        case 'view'     : return <NavigationMenuItemCustomView ref={ref} {...props} viewId={props.item.data.id} />
        case 'portfolio': return <NavigationMenuItemPortfolio ref={ref} {...props} portfolio={props.item.data}/>
        default:
            return null
    }
})

export default NavigationMenuProjectsViewsItem